import validator from 'validator';

export const isPhoneNumer = (text: string) => {
  if (!text || !text.length) {
    return false;
  }

  return validator.isMobilePhone(text);
};
